import styled from 'styled-components';

import { colors } from 'config';

export const DashboardWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-flow: row;
`;

export const CellWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const NullValueMarker = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #00a91c;
  margin: 1em 0;
  padding: 0;
  width: 1em;
`;

export const ContainerWrapper = styled.div`
  font-size: 14px;
  .paper {
    padding: 4em 7.25em;
    max-width: 976px;
    margin: 1em auto 6em;
  }
  section:first-of-type h2 {
    margin-top: 0.5em;
  }
  section p:nth-child(6) {
    margin-bottom: unset;
  }
  header {
    h1 {
      margin-bottom: unset;
      font-size: 30;
      font-weight: 300;
    }
    h2 {
      font-size: 20;
      font-weight: 200;
    }
  }
  p {
    strong {
      color: ${colors.uswds.blue60};
    }
  }
  ol {
    margin-top: unset;
    list-style: none;
    padding-inline-start: 1.2em;
    ul {
      margin-bottom: 1em;
      list-style: disc;
      padding-inline-start: 2em;
    }
  }
`;
